import { CognitoUserPool } from "amazon-cognito-identity-js";
import { decryptData, getSecret } from "../common/common";
import { SSMKeys } from "../common/common";

const getAuthPool = async () => {
    const poolId = await getSecret(SSMKeys.authPoolId).then((res) => decryptData(res));
    const clientId = await getSecret(SSMKeys.authClientId).then((res) => decryptData(res));

    const awsAuthPool = {
        UserPoolId: poolId,
        ClientId: clientId,
    };

    return new CognitoUserPool(awsAuthPool);
};

export default getAuthPool;